import { useEffect, useState } from "react";
import { IconButton, TableCell } from "@mui/material";
import Search from "@mui/icons-material/Search";

import { reportTemplateHistoricalApi } from "@/main/api";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import { KOGTableRow } from "@/main/components/shared/boxGrid/styles";
import KOGSection from "@/main/components/shared/kogSection/kogSection";
import KOGPaginationGrid from "@/main/components/shared/paginationGrid/paginationGrid";
import RenderTooltipMessage from "@/main/components/shared/renderTooltipMessage/renderTooltipMessage";
import { ReportTemplateHistoricalResponse } from "@/main/models/response";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";
import { getTranslateByKey } from "@/main/services/utils";

import * as S from "./styles";
import RegisterReportTemplateHistoricModal from "../registerReportTemplateHistoricModal/registerReportTemplateHistoricModal";
import { ReportTemplateHistoricalRequest } from "@/main/models/request";

interface ISectionHistoryProps {
	guidTemplate: string | null;
	isReloadHistory: boolean;
}

function SectionHistory({ guidTemplate, isReloadHistory }: ISectionHistoryProps) {
	const [dataGrid, setDataGrid] = useState<ReportTemplateHistoricalResponse[]>([]);
	const [isOpenModalHistory, setIsOpenModalHistory] = useState(false);
	const [selectedGuidHistorical, setSelectedGuidHistorical] = useState<string | null>(null);
	const [formFilters, setFormFilters] = useState<ReportTemplateHistoricalRequest | null>(null);

	async function fetchData(request: any) {
		return reportTemplateHistoricalApi.getHistoric(request).then((response) => response.data);
	}

	function handleClickOpenDetailHistoric(guidHistoric: string) {
		setSelectedGuidHistorical(guidHistoric);
		setIsOpenModalHistory(true);
	}

	function handleModalCloseDetailHistoric() {
		setSelectedGuidHistorical(null);
		setIsOpenModalHistory(false);
	}

	function searchHistory() {
		setDataGrid([]);
		setFormFilters(null);
		const request: ReportTemplateHistoricalRequest = {
			guidTemplate,
			pageIndex: PaginationEnum.PageIndexIntial,
			pageSize: PaginationEnum.PageSize30,
		};

		setFormFilters(request);
		// fetchData(request);
	}

	useEffect(() => {
		searchHistory();
	}, [isReloadHistory]);

	const rowHeaders = [
		getTranslateByKey("information.description"),
		getTranslateByKey("information.dateTimeUser"),
		getTranslateByKey("information.actions"),
	];

	const sizeColumns = ["45%", "responsive", "100px"];

	const ID_SCROLLABLE_TARGET = "id-scrollable-target-section-history";

	return (
		<KOGSection title={getTranslateByKey("information.history")}>
			<S.ContainerBodyHistory id={ID_SCROLLABLE_TARGET}>
				<KOGPaginationGrid
					fetchEqualFilters
					showEndMessage={false}
					showTitleResults={false}
					dataGrid={dataGrid}
					formFilters={formFilters}
					idScrollableTarget={ID_SCROLLABLE_TARGET}
					setDataGrid={setDataGrid}
					fetchMore={fetchData}
				>
					<BoxGrid marginCustom="0" rowHeaders={rowHeaders} sizeColumns={sizeColumns}>
						{dataGrid.map((historic, index) => (
							<KOGTableRow key={historic.guidHistoric} $notClickable>
								<TableCell>{historic.description}</TableCell>
								<TableCell>
									{historic.formatedDate} - {historic.user}
								</TableCell>
								<TableCell>
									<S.TableIcons>
										<IconButton
											id={`id-button-detail-historic-${index}`}
											onClick={() => handleClickOpenDetailHistoric(historic.guidHistoric)}
										>
											<RenderTooltipMessage tooltipMessage={getTranslateByKey("information.historyDetails")}>
												<Search fontSize="medium" />
											</RenderTooltipMessage>
										</IconButton>
									</S.TableIcons>
								</TableCell>
							</KOGTableRow>
						))}
					</BoxGrid>
				</KOGPaginationGrid>
			</S.ContainerBodyHistory>
			<RegisterReportTemplateHistoricModal
				isOpen={isOpenModalHistory}
				onClose={handleModalCloseDetailHistoric}
				guidHistorical={selectedGuidHistorical}
			/>
		</KOGSection>
	);
}

export default SectionHistory;
